import { render, staticRenderFns } from "./BaseLogs.vue?vue&type=template&id=2cd74ce4"
import script from "./BaseLogs.vue?vue&type=script&lang=js"
export * from "./BaseLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports